import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';

import { dateFormat } from '../../../../util/date';
import { capitalizeFirstLetter } from '../../../../util/text';

import { getConversationCoverData, getConversationOption, getConversationDates, getConversationMessagesCount, getConversationParticipants, hasBlockingMissingMedias } from '../../ConversationActions';
import withRouter from '../../../../components/Router/WithRouter';
import IntlCountFormat from '../../../Intl/components/view/IntlCountFormat';
import ConversationCardActions from './ConversationCardActions';

class ConversationListItem extends Component {
    renderDates() {
        const { conversation } = this.props;
        const { start, end } = getConversationDates(conversation);
        const format = 'LL';

        if(start) {
            const startLabel = dateFormat(start, format);
            const endLabel = end && dateFormat(end, format);
            return endLabel && endLabel !== startLabel ? `${startLabel} → ${endLabel}` : startLabel;
        }

        return conversation.dateStatus && dateFormat(conversation.dateStatus.pending, format);
    }

    renderStat(icon, value, labelId, labelDefault) {
        const count = value > 0 ? value : 0;
        return (
            <div className="conversations-lux-card__stat">
                <FontAwesome name={icon} className="conversations-lux-card__stat-icon" />
                <div className="conversations-lux-card__stat-value">{count > 0 ? <IntlCountFormat value={count} /> : '∅'}</div>
                <div className="conversations-lux-card__stat-label"><FormattedMessage id={labelId} defaultMessage={labelDefault} values={{ count }} /></div>
            </div>
        );
    }

    render() {
        const { conversation, intl, isMergeMode, isSelected, onToggleSelection } = this.props;
        const participants = getConversationParticipants(conversation);
        const dates = this.renderDates();
        const blockingMissingMedias = hasBlockingMissingMedias(conversation);

        return (
            <div className={classNames('conversations-lux-card', isMergeMode && 'conversations-lux-card--selectable', isMergeMode && isSelected && 'conversations-lux-card--selected', blockingMissingMedias && 'conversations-lux-card--missing-medias')}>
                <span className="conversations-lux-card__accent" aria-hidden="true" />
                <div className="conversations-lux-card__head">
                    <span className="conversations-lux-card__icon">
                        {(getConversationOption(conversation, 'types') || getConversationOption(conversation, 'providers')).map(provider => <img key={provider} src={`${config.staticUrl}assets/images/${provider}.png`} alt="" role="presentation" />)}
                    </span>
                    <div className="conversations-lux-card__titles">
                        <span className="conversations-lux-card__title">{getConversationCoverData(conversation, 'from')} {getConversationCoverData(conversation, 'to')}</span>
                        {participants.length > 0 && <span className="conversations-lux-card__people">{participants.map(participant => participant.displayName).join(', ')}</span>}
                    </div>
                </div>

                {(dates || conversation.status || blockingMissingMedias) && (
                    <div className="conversations-lux-card__meta">
                        {dates && <div className="conversations-lux-card__dates">{dates}</div>}
                        {conversation.status && (
                            <span className="conversations-lux-card__status">
                                {intl.formatMessage({ id: `conversationStatus${capitalizeFirstLetter(conversation.status)}`, defaultMessage: capitalizeFirstLetter(conversation.status) })}
                            </span>
                        )}
                        {blockingMissingMedias && (
                            <span className="conversations-lux-card__status conversations-lux-card__status--warning">
                                <FontAwesome name="exclamation-triangle" />{' '}
                                <FormattedMessage id="conversationMissingMediasBadge" defaultMessage="Missing medias" />
                            </span>
                        )}
                    </div>
                )}

                <div className="conversations-lux-card__stats-grid">
                    {this.renderStat('comment', getConversationMessagesCount(conversation), 'conversationMessagesCount2', 'message(s)')}
                    {this.renderStat('image', conversation.imagesCount, 'conversationMessagesImagesCount2', 'image(s)')}
                    {this.renderStat('video', conversation.mediasCount, 'conversationMessagesMediasCount2', 'audio/video/gif')}
                </div>

                {!isMergeMode && <ConversationCardActions conversation={conversation} />}

                {isMergeMode && (
                    <button
                        type="button"
                        className="conversations-lux-card__merge-overlay"
                        onClick={() => onToggleSelection(conversation, !isSelected)}
                        aria-pressed={isSelected}
                        aria-label={intl.formatMessage({ id: isSelected ? 'conversationMergeUnselect' : 'conversationMergeSelect', defaultMessage: isSelected ? 'Unselect this conversation' : 'Select this conversation' })}
                    >
                        {isSelected && <FontAwesome name="check-circle" className="conversations-lux-card__merge-check" />}
                    </button>
                )}
            </div>
        );
    }
}

ConversationListItem.defaultProps = {
    isMergeMode: false,
    isSelected: false,
    onToggleSelection: null,
};

ConversationListItem.propTypes = {
    conversation: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    isMergeMode: PropTypes.bool,
    isSelected: PropTypes.bool,
    onToggleSelection: PropTypes.func,
};

export default connect()(withRouter(injectIntl(ConversationListItem)));
